
<template>
  <div>
    <dialog-create-client></dialog-create-client>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import DialogCreateClient from '../../components/client/DialogCreateClient.vue'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'NewClientPage',
  //mixins: [ validations ],
  components: {
    DialogCreateClient
    //ComponentName: () => import(''),
  },
  data() {
    return {
    }
  },
  methods: {
    name() {
      
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>